import { c as _c } from "react/compiler-runtime";
import { Text } from '@endurancewarranty/ui';
import { useAppRouter } from '@hooks/navigation';
import { AppRouteEnum } from '@lib/enums';
import { ParameterTypeEnum } from '@lib/enums/ParameterTypeEnum';
import { QuoteTransactionModalFooter } from '@quoteId/payments/_components/QuoteTransactionModalFooter';
import { sidebarDialogAtom } from '@states/dialogs/sidebarDialogAtom';
import { useJotaiAtom } from '@states/jotai/hooks';
import type { FC } from 'react';
export type Props = {
  onClose: () => void;
  params: Record<number, string>;
};
export const InvalidSelectedPlan: FC<Props> = t0 => {
  const $ = _c(9);
  const {
    onClose,
    params
  } = t0;
  const router = useAppRouter();
  const [, setSidebarDialogState] = useJotaiAtom(sidebarDialogAtom);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Text.Body size="lg" fontWeight="bold" align="left">Validate Plan</Text.Body>;
    t2 = <Text.Body align="left" margin="mt-1">We need to validate the selected plan. This can happen if this file was opened in Moxy. Please confirm plan details before continuing.</Text.Body>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== params || $[3] !== router || $[4] !== setSidebarDialogState) {
    t3 = () => {
      setSidebarDialogState({
        isOpen: false,
        children: null
      });
      router.build(AppRouteEnum.QuoteFlowSelectPlan).setId(params[ParameterTypeEnum.QuoteId]).go();
    };
    $[2] = params;
    $[3] = router;
    $[4] = setSidebarDialogState;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onClose || $[7] !== t3) {
    t4 = <div className="hide-scrollbar h-full overflow-y-auto">{t1}{t2}<QuoteTransactionModalFooter isLoading={false} nextText="Validate" onNextClick={t3} onClose={onClose} /></div>;
    $[6] = onClose;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};